import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface UncompleteEstimateRequestPlanRequest {
  actionName: 'uncompleteEstimateRequestPlan';
  request: mtechnavi.api.estimation.IUncompleteEstimateRequestPlanRequest[];
}

export const uncompleteEstimateRequestPlan = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.estimation.IUncompleteEstimateRequestPlanRequest[]
) => {
  const fullMethodName =
    'mtechnavi.api.estimation.EstimateSenderService/UncompleteEstimateRequestPlan';

  const result = req.map((item) => {
    return worker.invokeListRequest<
      mtechnavi.api.estimation.IUncompleteEstimateRequestPlanRequest,
      void
    >(fullMethodName, {
      estimateRequestPlanId: item.estimateRequestPlanId,
    });
  });
  await Promise.all(result);
};
